module.exports = __webpack_public_path__ + "static/jorge1-3ecf3eec9da6e12a3489dcb1c9adec01.png";